import * as Yup from 'yup'



Yup.addMethod(Yup.string, "valida_patente", function (errorMessage) {
    return this.test(`valida_patente`, errorMessage, function (patente) {
        if (patente && patente.length > 0) {
            var regex = /^[a-z]{2}[\.\- ]?[0-9]{2}[\.\- ]?[0-9]{2}|[b-d,f-h,j-l,p,r-t,v-z]{2}[\-\. ]?[b-d,f-h,j-l,p,r-t,v-z]{2}[\.\- ]?[0-9]{2}$/i;
            if (regex.test(patente)) {
                return true;
            } else {
                return false;
            }
        }
     
        return true;
  })
})
export const validationSchemas = (montoNetoCompara) => {
   
    let validationObject = { };
   
  
     
      validationObject["codMotivoSolicitud"] = Yup.date().required('Este Campo es obligatorio.');
      validationObject["porcPropuesto"] = Yup.number().required('Este campo es obligatorio').min(0, "El porciento no puede ser negativo").max(100,"El porciento no puede ser mayor a 100");
      validationObject["montoPropuesto"] = Yup.string().test(
        "len",
        "No puede ser mayor a monto neto",
        (val) => {
          if (val === undefined) {
            return true;
          }
          return parseInt(val.replace(/\./g, '')) >= 0 && parseInt(val.replace(/\./g, ''))  <= montoNetoCompara;
        }
      );
     
     validationObject["comentario"] = Yup.string().test(
       "len",
       "No puede exeder 1000 caracteres..",
       (val) => {
         if (val === undefined) {
           return true;
         }
         return val.length === 0 || (val.length >= 0 && val.length <= 1000);
       }
     );
     
      
  
    return Yup.object().shape(validationObject);
  }
  
 

